var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgMarketingMaterial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.938 79.268c21.624 0 39.154-17.58 39.154-39.268 0-21.688-17.53-39.27-39.154-39.27C18.313.731.784 18.312.784 40c0 21.687 17.53 39.268 39.154 39.268Z",
    fill: "#EAF1FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.027 53.195-6.553 2.577-5.061-8.986 5.061-4.28 6.553 10.69Zm16.92-31.823L26.445 38.187l7.618 12.437 23.163-9.867-12.279-19.385Zm-4.228 39.502-6.656-10.249-6.036 2.57 4.81 7.68h7.882Z",
    fill: "#3585F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.306 23.14c4.429 1.074 7.153 5.555 6.075 9.996M53.643 17.96c7.127 2.37 10.994 10.08 8.632 17.235",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m26.445 38.187-4.97 4.318 6.552 10.69 6.036-2.57-7.618-12.438Z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingMaterial);
export default __webpack_public_path__ + "static/media/MarketingMaterial.4ae3dc1330ca1fc0288764dc2bd341e6.svg";
export { ForwardRef as ReactComponent };